const questionareFields = {
  Smoke_In_Vehicle: "Smoke_In_Vehicle",
  Original_Factory_Rims: "Original_Factory_Rims",
  Tires_Repld_12_Months: "Tires_Repld_12_Months",
  Windshield_Crack: "Windshield_Crack",
  Extended_Warranty: "Extended_Warranty",
  Vehicle_Drivable: "Vehicle_Drivable",
  vehicle_drivable_not_explanation: "vehicle_drivable_not_explanation"
};

export {
  questionareFields
};